// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pAGcQ","toggleWrap":"styles_toggleWrap__39uW4","content":"styles_content__3HJ1l","selectAreaCode":"styles_selectAreaCode__ukscQ"};